module.exports = __webpack_public_path__ + "static/img/topIcon.cd10efb4.png";